<template>
  <v-text-field v-if="useVuetify" :style="{ width: '205px'}" v-bind="$attrs" :model-value="modelValue" @update:modelValue="emit('update:modelValue', $event)">
    <slot></slot>
  </v-text-field>
  <input v-else type="text" v-bind="$attrs" :value ="modelValue" @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"/>
</template>

<script setup lang="ts">
import { inject } from 'vue';

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['update:modelValue'])
defineProps({
  modelValue: String
})
const useVuetify = inject("useVuetify",false);
</script>